var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-app-mission',{attrs:{"missions":_vm.missions,"mini":_vm.mini},on:{"open":function($event){_vm.mini = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }